import api from '@utils/api';

export const getActiveAnnouncement = async () => {
  try {
    const response = await api.get('/announcement/active');
    // Axios entrega '' (cadena vacía), no null, si el cuerpo viene vacío.
    return response.data || null;
  } catch (error) {
    console.error('Error fetching active announcement:', error);
    throw error;
  }
};

export const getAnnouncement = async () => {
  try {
    const response = await api.get('/announcement');
    return response.data;
  } catch (error) {
    console.error('Error fetching announcement:', error);
    throw error;
  }
};

export const saveAnnouncement = async (payload) => {
  try {
    const response = await api.put('/announcement', payload);
    return response.data;
  } catch (error) {
    console.error('Error saving announcement:', error);
    throw error;
  }
};

export const activateAnnouncement = async () => {
  try {
    const response = await api.post('/announcement/activate');
    return response.data;
  } catch (error) {
    console.error('Error activating announcement:', error);
    throw error;
  }
};

export const deactivateAnnouncement = async () => {
  try {
    const response = await api.post('/announcement/deactivate');
    return response.data;
  } catch (error) {
    console.error('Error deactivating announcement:', error);
    throw error;
  }
};
